<template>
    <div id="VendorEstimateList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="cantAccessPage === true">
            <div class="admin-page-content customer-detail">
                <div class="btn-groups text-right special-btns">
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                        <i class="fp-export"></i> Export
                    </a>
                    <template v-if="canAddWoVendorEstimate == true">
                        <router-link class="btn btn-primary" v-bind:to="{name: 'VendorEstimateCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </template>
                </div>
                <!-- <div class="FiltersLabel">Filters</div> -->
                <data-table-filter-config :moduleName="'listWoEstimateVendor'" ref="filtervendorEstimateList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                <div class="data-table bg-white overflow-hidden">
                  <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                  <section class="bg-white data-table">
                          <custom-pagination
                              :page-changed="onPageChange"
                              :per-page-changed="onPerPageChange" :moduleName="'listWoEstimateVendor'" :position="'top'">
                          </custom-pagination>

                          <vue-good-table
                          ref="listWoVendorTable"
                          mode="remote"
                          title="Work Orders"
                          @on-page-change="onPageChange"
                          @on-selected-rows-change="selectionChanged"
                          @on-column-filter="onColumnFilter"
                          @on-per-page-change="onPerPageChange"
                          @on-sort-change="onSortChange"
                          @on-select-all="onSelectAll"
                          :totalRows="totalRecords"
                          :columns="userColumns"
                          :rows="rows"
                          :pagination-options="{
                                  enabled: false,
                                  position: 'both',
                                  perPage: perPage,
                                  perPageDropdown:dropDownPerPage,
                                  dropdownAllowAll: false,
                              }"
                          :select-options="{
                              enabled: true,
                              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                              selectionInfoClass: 'custom-class',
                              selectionText: 'rows selected',
                              clearSelectionText: 'clear',
                              }"
                          :search-options="{
                              enabled: false,
                              }">

                          <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                              <div :key="key">
                              <div v-if="props.column.field == 'action'" class='text-center'>
                                  <template v-if="canEditWoVendorEstimate == true && props.row.status.toLowerCase() != 'approved'">
                                      <router-link title="Edit Vendor Estimate" class="fp-edit" v-bind:to="{name: 'VendorEstimateEdit',params:{id:props.row.id}}"></router-link>
                                  </template>
                              </div>
                              <div v-else-if="props.column.field == 'vendor_estimate_no' && canViewWoVendorEstimate === true" class='text-center'>
                                  <router-link title="View Vendor Estimate" class="color-blue"  v-bind:to="{name: 'VendorEstimateView',params:{id:props.row.id}}">{{props.row.vendor_estimate_no}}</router-link>
                              </div>
                              <div v-else-if="props.column.field == 'po_no' && canViewPo === true" class='text-center'>
                                  <router-link title="View Vendor Purchase Order" class="color-blue"  v-bind:to="{name: 'VendorPurchaseOrderView',params:{id:props.row.vendor_po_id},query:{from:'vendor_est'}}">{{props.row.po_no}}</router-link>
                              </div>
                              <div v-else>
                                  {{props.formattedRow[props.column.field]}}
                              </div>
                              </div>
                          </template>
                          <div slot="selected-row-actions">
                              <template v-if="canCreatePurchaseOrder == true">
                                  <button id="createPurchaseOrderBtn" v-on:click.prevent="createPurchaseOrder" class="btn btn-primary">Create Purchase Order</button>
                              </template>
                              <template v-if="canDeleteWoVendorEstimate == true">
                                  <button id="deleteWorkOrderBtn" v-on:click.prevent="workOrderDelete" class="btn btn-primary">Delete</button>
                              </template>
                          </div>

                          </vue-good-table>
                          <custom-pagination
                              :page-changed="onPageChange"
                              :per-page-changed="onPerPageChange">
                          </custom-pagination>
                  </section>
                </div>
            </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
    </div>
</template>
<script>

import EventBus from ".././event-bus";
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';


    export default {
        name: "VendorEstimateList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            estimateVendorWoVal: {
                type: String,
                required: false,
                default: undefined
            }
        },
        data: () => ({

            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: '#Estimate',
                    field: 'vendor_estimate_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Work Order No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: '#PO',
                    field: 'po_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Purchase Order No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Vendor',
                    field: 'vendor_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'User',
                    field: 'user_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Maintenance Type',
                    field: 'maintenance_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Maintenance Type", // placeholder for filter input
                        filterDropdownItems: ['Preventive Maintenance', 'Federal Maintenance','Other'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Open Date',
                    field: 'open_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Priority',
                //     field: 'priority',
                //     fpFieldType:"option",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Priority", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Location',
                //     field: 'location',
                //     fpFieldType:"option",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Location", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: ['Open','Sent' ,'Responded', 'Approved'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            canDeleteWoVendorEstimate: false,
            vehicle_id:"",
            loading:false,
            costCodeArr:[],
            canEditWoVendorEstimate: false,
            canViewWoVendorEstimate: false,
            canAddWoVendorEstimate: false,
            canCreatePurchaseOrder:false,
            canViewPo:false,
            pageKey:"_vendor_estimate_list",
            batchProcess:0,
            batchNum:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_vendor_estimate') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_vendor_estimate') {
                            self.canAddWoVendorEstimate = true;
                            self.canEditWoVendorEstimate = true;
                        }
                        if (permissions[i].name == 'delete_vendor_estimate') {
                            self.canDeleteWoVendorEstimate = true;
                        }
                        if (permissions[i].name == 'view_vendor_estimate') {
                            self.canViewWoVendorEstimate = true;
                        }
                        if (permissions[i].name == 'add_purchase_order') {
                            self.canCreatePurchaseOrder = true;
                        }
                        if (permissions[i].name == 'view_purchase_order') {
                            self.canViewPo = true;
                        }

                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('work_order');
        },
        mounted: function() {
            var self = this;

            this.$root.$on('work_order', () => {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.getPermissions();
                self.loadList();
            });

            //when component list directly call from url instead of in view page than call permission request

            self.getPermissions();


        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listWoVendorTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },


            loadList() {
                var data = this.$refs['listWoVendorTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listWoVendorTable'].selectedRows[i].id)
                }
                var path = window.location.pathname;
                var segments = path.split("/");

                self.loading = true;

                var fields = {
                    vehicle_id:segments[3],
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use,
                    selectedRows:use
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-estimate/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        if (data.status == "success") {

                            if (self.action == 'delete'){

                                self.action = "list";
                                self.$refs.filtervendorEstimateList.clearSelectAll();

                                // self.$swal('','Vendor Estimate deleted successfully','success');
                                var msg = "";

                                msg = data.content.deleted+" records have been deleted";

                                if ( data.content.skipped == 1 ) {
                                    msg +=" and "+data.content.skipped+" record was approved so skipped that record";
                                } else if ( data.content.skipped > 1 ) {
                                    msg +=" and "+data.content.skipped+" records were approved so skipped that records";
                                }
                                msg +=".";

                                self.$swal('',msg,data.status);
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();

                            }else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;

                                for(var i=0; i<self.columns.length; i++) {
                                    if ( self.columns[i].field == 'cost_code' ) {
                                        console.log(data.costCodes)
                                        self.columns[i].filterOptions.filterDropdownItems = data.costCodes;
                                    }
                                }

                                if (self.estimateVendorWoVal == "vendor") {

                                    EventBus.$emit("custWoCount", data.content.customerWoEstimateCnt);
                                    EventBus.$emit("vendorWoCount", data.content.vendorWoEstimateCnt);

                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, false,'vendor-estimate-list');
                    }
                });
            },

            workOrderDelete() {
                // var data = this.$refs['listWoVendorTable'].selectedRows;
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Vendor Estimate?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        self.loadList();

                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Vendor Estimate? ')) {
                //
                // }


            },

            createWorkOrderEstimate() {

                var self = this;

                if ( this.$refs['listWoVendorTable'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one work order.",'info');
                    return;
                }

                if ( this.$refs['listWoVendorTable'].selectedRows[0].work_order_estimate_no != '-' ) {
                    self.$swal('',"Estimate has already been created.",'info');
                    return;
                }

                if (confirm('A new work Order Estimte will create from selected work order')) {
                    this.$router.push({ name: 'CustomerEstimateCreate', params:{workOrderId: this.$refs['listWoVendorTable'].selectedRows[0].id, redirectFrom: 'WorkOrderList'}})
                }

            },
            createPurchaseOrder() {

                var self = this;

                if ( this.$refs['listWoVendorTable'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one estimate.",'info');
                    return;
                }

                if ( this.$refs['listWoVendorTable'].selectedRows[0].vendor_po_id != '' ) {
                    self.$swal('',"Purchase Order has already been created.",'info');
                    return;
                }

                if (confirm('A new purchase Order will create from the estimate')) {
                    this.$router.push({ name: 'VendorPurchaseOrderCreate', params:{estimateWoId: this.$refs['listWoVendorTable'].selectedRows[0].id, redirectFrom: 'VendorEstimateList'}})
                }

            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listWoVendorTable'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/workorderestimate/VendorEstimateList.vue